const removeSpecialCharacters = (str) => {
  const characters = [
    { letter: 'A', special: /[àâ]/gi },
    { letter: 'ae', special: /ä/gi },
    { letter: 'C', special: /ç/gi },
    { letter: 'E', special: /[èéêë]/gi },
    { letter: 'I', special: /[îï]/gi },
    { letter: 'N', special: /ñ/gi },
    { letter: 'O', special: /ô/gi },
    { letter: 'oe', special: /ö/gi },
    { letter: 'U', special: /[ùû]/gi },
    { letter: 'ue', special: /ü/gi },
  ];

  const replacedString = characters.reduce(
    (prevStr, c) => prevStr.replace(c.special, c.letter),
    str
  );

  return replacedString;
};

export default function getNameOnCardFormat(
  {
    firstName = '', middleName = '', surname = '',
  } = {},
  maxLength = 20
) {
  const formats = ['FMS', 'FiS', 'FS', 'IS'];
  const conversions = {
    F: firstName,
    I: firstName[0],
    M: middleName,
    i: middleName[0],
    S: surname,
  };

  const formatToString = (format) => removeSpecialCharacters(
    [...format]
      .map((bit) => conversions[bit])
      .join(' ')
      .replace(/\s{2,}/, ' ')
      .trim()
  );

  const filteredFormats = formats.filter((format) => [...format].some((bit) => conversions[bit])
  );

  const formatted = filteredFormats.reduce(
    // eslint-disable-next-line max-params
    (result, format, index, array) => {
      const formattedNameOnCard = formatToString(format);

      if (formattedNameOnCard.length > maxLength) {
        if (index === array.length - 1) {
          result.add(formattedNameOnCard.slice(0, maxLength));
        }
      } else {
        result.add(formattedNameOnCard);
      }

      return result;
    },
    new Set()
  );

  return [...formatted].map((format) => ({
    value: format.toUpperCase(),
    label: format.toUpperCase(),
  }));
}
